import { AxiosResponse } from 'axios';
import { currencyExchangeCreate, currencyExchangeList } from '@/api/currencyExchange';
import { AppError } from '@/errors/appError';
import type { CurrencyExchangeItem } from '@/models/currencyExchange';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { ICurrencyExchangeApiListResponse, ICurrencyExchangeCreateParams, ICurrencyExchangeMutationResponse } from '@/types/currencyExchange';

export const currencyExchangeService = {
    async list(params: IListParams<Record<string, never>>): Promise<AxiosResponse<ICurrencyExchangeApiListResponse>> {
        try {
            return await baseListService<ICurrencyExchangeApiListResponse>(currencyExchangeList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Currency exchange API Error:', e);
            throw new AppError('Unable to load currency exchange list, request error', { cause: e });
        }
    },

    async save(item: CurrencyExchangeItem): Promise<AxiosResponse<ICurrencyExchangeMutationResponse>> {
        return this.create({ rows: [item.toApiData()] });
    },

    async create(params: ICurrencyExchangeCreateParams): Promise<AxiosResponse<ICurrencyExchangeMutationResponse>> {
        try {
            return await currencyExchangeCreate(params);
        } catch (e) {
            console.error('Currency exchange create API Error:', e);
            throw new AppError('Unable to create currency exchange, request error', { cause: e });
        }
    },
};
